<div class="input-group mb-3">
  <span *ngIf="prefix" class="input-group-text">{{ prefix }}</span>
  <input #inputEl type="text" class="form-control" inputmode="decimal" [ngClass]="{ 'text-end': textEnd }"
         [attr.placeholder]="disabled ? '' : placeholder" [disabled]="disabled"/>
  <span *ngIf="suffix" class="input-group-text">{{ suffix }}</span>
</div>
<div *ngIf="limitHint" class="text-warning small mt-1" role="alert" aria-live="polite">
  {{ limitHint }}
</div>
